import script from "./PraxisAssistentAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./PraxisAssistentAvatar.vue?vue&type=script&setup=true&lang=js"

import "./PraxisAssistentAvatar.vue?vue&type=style&index=0&id=5f04b56d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f04b56d"]])

export default __exports__